const CareerPathwaysSkillsLayout = <template>{{outlet}}</template>;

export default CareerPathwaysSkillsLayout;
